import Button from "@/components/Button";
import MeeyImage from "@/components/MeeyImage";
import VideoPlayer from "@/components/VideoPlayer";
import { APP_MEEYPROJECT_URL } from "@/constants/environment";
import { ProjectContext } from "@/context/project.context";
import { formatNumber } from "@/utils/number";
import { VideoItem } from "Models";
import Link from "next/link";
import { useContext, useState } from "react";

const ProjectVideoBox = () => {
  const [currentVideo, setCurrrentVideo] = useState<VideoItem>(null);
  const { projectVideos, project } = useContext(ProjectContext);

  return (
    <>
      <div className="bg-white rounded-lg py-3w-full">
        {projectVideos?.length
          ? projectVideos.slice(0, 3).map((card) => (
              <div
                key={card._id}
                className="relative cursor-pointer mb-3"
                onClick={() => setCurrrentVideo(card)}>
                <MeeyImage
                  src={card?.avatar.uri}
                  className="rounded-md w-full"
                />
                <div className="absolute  w-9 h-9 bg-[rgba(0,0,0,0.4)] rounded-full flex items-center justify-center top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
                  <i className="mrv mrv-play_arrow text-white text-fs-28"></i>
                </div>
                <div className="absolute  bottom-2 left-3 text-white">
                  <div className="font-semibold line-clamp-1">
                    {card?.title}
                  </div>
                  {card.totalView ? (
                    <div className="text-fs-12 flex items-center">
                      <i className="mrv mrv-visibility mr-1 text-base"></i>{" "}
                      {formatNumber(card.totalView) + " lượt xem"}
                    </div>
                  ) : null}
                </div>
              </div>
            ))
          : null}

        <Link
          className="font-medium"
          target="_blank"
          href={
            APP_MEEYPROJECT_URL +
            "/project/" +
            project.slug +
            "-" +
            project.shortId
          }>
          <Button
            btnType="outline"
            color="primary"
            className="w-full flex justify-center">
            Xem thêm video đánh giá
          </Button>
        </Link>
      </div>

      {currentVideo ? (
        <div className="fixed w-screen h-screen bg-black-1000 top-0 left-0 z-[200]">
          <div
            className="absolute top-4 right-4  text-fs-24 z-20"
            onClick={() => setCurrrentVideo(null)}>
            <i className="mrv mrv-close text-white"></i>
          </div>

          <VideoPlayer
            options={{
              autoplay: "muted",
              muted: true,
              controls: true,
              responsive: true,
              preload: "metadata",

              preferFullWindow: true,
              fluid: true,
              sources: [
                {
                  src: currentVideo?.url,
                },
              ],
            }}
          />
        </div>
      ) : null}
    </>
  );
};

export default ProjectVideoBox;
